export const biochemicalDisordersModule = {
  id: "biochemical-disorders",
  title: "Biochemical Disorders",
  sections: [
    {
      type: "text",
      content:
        "Inborn errors of metabolism often present in infancy with lethargy, vomiting, or seizures.",
    },
    {
      type: "question",
      text: "Phenylketonuria is caused by deficiency of:",
      options: ["Phenylalanine hydroxylase", "Glucose-6-phosphatase", "Pyruvate dehydrogenase", "HMG-CoA reductase"],
      correct: 0,
      explanation: "PKU is due to phenylalanine hydroxylase deficiency.",
    },
  ],
};
